import { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { isSessionInvalidError, logoutToHome } from "../utils/authSession";

const useAuthSessionGuard = () => {
  const { getAccessTokenSilently, logout } = useAuth0();

  const getAccessTokenOrLogout = useCallback(async () => {
    try {
      return await getAccessTokenSilently();
    } catch (error) {
      if (isSessionInvalidError(error)) {
        logoutToHome(logout);
        return null;
      }
      throw error;
    }
  }, [getAccessTokenSilently, logout]);

  const handleUnauthorizedResponse = useCallback(
    (response) => {
      if (response?.status === 401) {
        logoutToHome(logout);
        return true;
      }
      return false;
    },
    [logout]
  );

  return {
    getAccessTokenOrLogout,
    handleUnauthorizedResponse,
  };
};

export default useAuthSessionGuard;
